import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import {
  getCodeData,
  getInitFormData,
  getInitSheet,
  getTablebySql,
  isDateValue,
  isNumeric,
} from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import { ColumnConfig } from "@shared/components/Grid/types";

import SnGrid from "@shared/components/Grid/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";

import SnButton from "@shared/components/SnButton";

import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import { Save, Shop } from "@mui/icons-material";
import ExcelUpload from "@widgets/commonpopup/ExcelUpload";
import { showPopupModal } from "@widgets/CommonModal";
import {
  ProcessCellForExportParams,
  ProcessHeaderForExportParams,
} from "ag-grid-community";
import EXC000000000029003_POP_001 from "./EXC000000000029003_POP_001";

interface Props {
  Menuprops: menuInfo;
}

const EXC000000000029003 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRef = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<ColumnConfig[]>([]);
  const [dataSource1, setDataSource1] = useState<any[]>([]); // 초기값을 빈 배열로 설정
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);
  const { userInfo } = global(); // Login user 정보
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridRef.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  const onSearch = async () => {
    const modifiedRowsH = gridRef.current.getChange();
    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }

    try {
      const p = {
        ...searchRef.current.getFormdata(),
        g_cd_firm: userInfo.cd_firm,
        g_cd_cust: userInfo.cd_cust || "",
      };

      const params = {
        id: "exc000000000029003_01",
        params: p,
      };

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);

      const today = new Date(); // 오늘 날짜 기준

      const updatedData = data[0].map((row: any) => {
        if (!row.dt_end_so) {
          return { ...row, month: "" }; // 종료일 없음 → 빈칸
        }

        const endStr = row.dt_end_so.toString();
        const endDate = new Date(
          parseInt(endStr.slice(0, 4)),
          parseInt(endStr.slice(4, 6)) - 1,
          parseInt(endStr.slice(6, 8))
        );

        if (isNaN(endDate.getTime())) {
          return { ...row, month: "" }; // 날짜 파싱 오류 → 빈칸
        }

        // 개월 차이 계산 (음수 가능)
        let yearDiff = endDate.getFullYear() - today.getFullYear();
        let monthDiff = endDate.getMonth() - today.getMonth();
        let totalMonths = yearDiff * 12 + monthDiff;

        // 같은 달일 경우, 날짜 차이도 반영
        if (endDate.getDate() >= today.getDate()) {
          totalMonths += 1;
        }

        return { ...row, month: totalMonths.toString() };
      });

      setDataSource1(updatedData);
      await new Promise((resolve) => setTimeout(resolve, 50));
      setGridFocus(true);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));

  const onSave = async () => {
    const dt: any = [];

    try {
      const displayedNodes = gridRef.current.api.getRenderedNodes();
      const rowCount = gridRef.current.api.getDisplayedRowCount();
      const selectedDataL = gridRef.current.api.getSelectedRows();
      const allRowData: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        allRowData.push(node.data);
      });

      const maxNoLine =
        allRowData.length > 0
          ? Math.max(...allRowData.map((row: any) => row.no_line || 0))
          : 0;

      if (rowCount === 0) return;
      if (selectedDataL.length === 0) {
        await showDialog(
          "error",
          "선택된 내용이 없습니다. 항목을 선택해 주세요."
        );
        return;
      }
      for (const node of displayedNodes) {
        if (!node?.data) continue;

        // if (!node.isSelected()) {

        //   showDialog("alter", "select row!");
        //   return;
        // }

        if (node.isSelected()) {
          if (!node.data.dt_start_2) {
            await showDialog("alter", "변경시작일은 필수 값입니다.");
            return;
          }
          const newData: any = {
            cd_firm: userInfo.cd_firm,
            no_asset: node.data.no_asset,
            //no_line: node.data.no_line + 1,
            no_line: maxNoLine + 1,
            yn_end: "Y",
            cd_user_reg: userInfo.cd_user,
            dt_start: node.data.dt_start_2,
            cd_emp: node.data.cd_emp_2,
            cd_dept: node.data.cd_dept_2,
            nm_dept: node.data.nm_dept_2,
            nm_emp: node.data.nm_emp_2,
            dt_return_plan: node.data.dt_return_plan_2,
            dc_rmk: node.data.dc_rmk_2,
            cd_cust_use:
              node.data.cd_cust_use_2?.trim() || node.data.cd_cust_pur,
            dc_rmk2: node.data.dc_rmk_4,
          };
          gridRef.current.setValue(node, "dt_start", node.data.dt_start_2);
          gridRef.current.setValue(node, "nm_dept", node.data.nm_dept_2);
          gridRef.current.setValue(node, "cd_emp", node.data.cd_emp_2);
          gridRef.current.setValue(node, "nm_emp", node.data.nm_emp_2);
          gridRef.current.setValue(
            node,
            "dt_return_plan",
            node.data.dt_return_plan_2
          );
          gridRef.current.setValue(node, "dc_rmk", node.data.dc_rmk_2);
          if (node.data.cd_cust_use_2 === "") {
            gridRef.current.setValue(
              node,
              "cd_cust_use",
              node.data.cd_cust_pur
            );
          } else {
            gridRef.current.setValue(
              node,
              "cd_cust_use",
              node.data.cd_cust_use_2
            );
          }
          gridRef.current.setValue(node, "dc_rmk2", node.data.dc_rmk_4);
          dt.push(newData);
        }
      }

      const SaveData: any = {
        mtl_asset_use: { insert: dt },
      };
      if (!SaveData.mtl_asset_use.insert[0]) {
        return;
      }
      await fnSave("EXC000000000029003_SAVE_01", SaveData);

      gridRef.current.resetUpdate();
      await onSearch();
    } catch (error) {}
  };

  const onExcelUpload = async () => {
    try {
      const component = (
        <EXC000000000029003_POP_001
          Menuprops={Menuprops} // 메뉴 정보 전달
          PkFields={["no_asset", "no_line"]} // PK 필드 목록 전달
          tableName="mtl_asset_use" // 저장할 테이블 이름
          controllerName="EXC000000000029003_SAVE_01" // 저장할 컨트롤러 이름
          userInfo={userInfo}
        />
      );

      const result = await showPopupModal({
        title: "엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "저장",
      });

      if (result?.excelUpload) {
        await onSearch();
      }

      if (result) {
        console.log("엑셀 업로드 완료:", result);
      } else {
        console.log("엑셀 업로드 취소됨");
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onExcelDownLoad = async () => {
    try {
      //          const rtn: any = await getInitSheet({});

      //          const columnKeys = rtn.grid.sheet1
      // .filter((col: any) => col.fg_visible === "Y")
      // .map((col: any) => col.cd_column);

      const columnKeys: string[] = [
        "no_asset",
        "nm_item",
        "dc_item_spec",
        "dt_start_2",
        "nm_dept",
        "cd_emp",
        "nm_emp",
        "dt_return_plan",
        "dc_rmk",
        "cd_cust_use",
        "dc_rmk2",
      ];

      //const flatRows = gridRef.current.getFlatDataFromGrid(columnKeys);
      const flatRowMap = gridRef.current.getFlatDataFromGrid(columnKeys);

      gridRef.current?.api.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: globalMenu.getState().activeMenuInfo.nm_menu + ".xlsx",
        sheetName: "Sheet1",
        processCellCallback: (params: ProcessCellForExportParams) => {
          const row = flatRowMap.get(params.node?.id ?? "");
          const colId = params.column.getColId();
          const cellValue = row?.[colId]?.value;
          const today = new Date();
          const todayStr = `${today.getFullYear()}/${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}`;
          if (colId === "dt_start_2") {
            // 값이 없거나 공백이면 todayform 사용
            return cellValue?.toString().trim() ? cellValue : todayStr;
          }

          return cellValue ?? "";
        },
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const gridref1btnclick = async (id: string) => {
    const rowCount = gridRef.current.api.getDisplayedRowCount();
    const selectedDataL = gridRef.current.api.getSelectedRows();
    if (rowCount === 0) return;

    if (selectedDataL.length === 0) {
      await showDialog(
        "error",
        "선택된 내용이 없습니다. 항목을 선택해 주세요."
      );
      return;
    }

    try {
      if (id === "aButton_1") {
        const confirm = await showDialog("confirm", "반납처리 하시겠습니까?");
        if (!confirm) return;

        const displayedNodes = gridRef.current.api.getRenderedNodes(); // Only visible rows

        for (const node of displayedNodes) {
          if (!node?.data) continue;

          if (node.isSelected()) {
            gridRef.current.setValue(node, "dt_end", todayform);

            const params = {
              cd_firm: userInfo.cd_firm,
              dt_end: node.data.dt_end,
              no_asset: node.data.no_asset,
            };
            await callApi("EXC000000000029003_SAVE_DT_END", params);

            if (node.data.cd_have === "002") {
              gridRef.current.setValue(node, "cd_have", "001");

              const params = {
                cd_firm: userInfo.cd_firm,
                cd_have: node.data.cd_have,
                no_asset: node.data.no_asset,
              };
              await callApi("EXC000000000029003_SAVE_HAVE", params);
            }
            showDialog("success", "성공적으로 저장되었습니다.");
          }
        }
      }
    } catch (error) {}
  };

  //#region onCellValueChanged
  const onCellValueChanged = async (event: any) => {
    if (!event) return;
    const { data, colDef, api } = event;

    if (colDef.field === "dt_start_2") {
      const custUseValue = data.cd_cust_use;
      data.cd_cust_use_2 = custUseValue;

      api.applyTransaction({ update: [data] });
    }
  };
  //#endregion

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex justify-end p-2 space-x-2"></div>
      <div className="flex-1">
        <SnGrid
          ref={gridRef}
          
          enableAddRow={true}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource1}
          enableExternalChart={false}
          chartColumns={["qt", "am"]}
          isEditable={true}
          rowSelection="multiple" // 단일 선택 모드
          ischeckboxSelection={true} // 체크박스 유무
        />
      </div>
    </div>
  );
});

export default EXC000000000029003;
